/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = ASC
 *
 * 1 = DESC
 */
export enum SortTypeEnum {
  ASC = 0,
  DESC = 1,
}
